import { render } from "./console.vue?vue&type=template&id=7b16bb02&scoped=true"
import script from "./console.vue?vue&type=script&lang=js"
export * from "./console.vue?vue&type=script&lang=js"

import "./console.vue?vue&type=style&index=0&id=7b16bb02&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b16bb02"]])

export default __exports__